import React, {useState, useRef} from 'react'; 
import { Link, useHistory } from 'react-router-dom';
import { Form, InputGroup} from 'react-bootstrap'  
import { useSelector, useDispatch } from "react-redux";
import ToastErrorMessage from '../Components/ToastErrorMessage'
import PhoneInput, { isValidPhoneNumber  } from 'react-phone-number-input'

function Login(props) {

    const {apiData} = useSelector(state => state);
    const history = useHistory();
    const dispatch = useDispatch();
    const [formValidated, setFormValidate] = useState(false);
    const [showPassword, passwordChange] = useState(false); 
    const [phoneNumber, setPhoneNumber] = useState();
 
    const passwordInput = useRef();



    //submit function
    let formSubmit = (event) => {  
        const form = event.currentTarget; 
        event.preventDefault();
        console.log(form.checkValidity())
        if (form.checkValidity() === false) { 
            setFormValidate(true)
            event.preventDefault(); 
            event.stopPropagation();
        }

        if(!isValidPhoneNumber(phoneNumber)){
            setFormValidate(true)
            event.preventDefault(); 
            event.stopPropagation();
            return false;
        }

        if(form.checkValidity() === true){  
            let data = { 
                mobile_number: phoneNumber,
                password: passwordInput.current.value, 
            }
            dispatch({ type: "API_LOADER_START" }) 
            dispatch({
                type: "LOGIN_API_CALL",
                payload: data
            }) 

        }
        
    }

    //toggle password
    let passwordToggle = () => {
        passwordChange((showPassword) ? false : true)
    }
 

    let apiSuccessResponse = () => {  
        if(apiData.status){
            let loginData = apiData.doctor; 
            localStorage.setItem('doctor_user_details', JSON.stringify(loginData))
            localStorage.setItem('doctor_jwt_token', apiData.token)
            dispatch({
                    type: "SIGN_IN",
                    payload: loginData
            }) 
            dispatch({type: "API_LOADER_STOP"}) 
            dispatch({type: "API_DATA_DESTROY"}) 

            history.push("/dashboard");
        }     
    }



    return (
        <>
        {
            (apiData.status) ? apiSuccessResponse() :  
            (apiData.message) ?   <ToastErrorMessage/> : null
        } 
        <div className="container-fluid  bg-white mainDiv p-0 row  ">
             
                <div className=" welcomeDiv  text-white ">
                <div className="login-logo text-lg-left text-md-left text-center px-3 ">
                    <img src={ require('../assets/images/logo_final.png') } width="150" height="45" alt="img" className="mt-3  " />
                </div>
                <div className="text-center px-lg-5 mx-lg-2 px-md-4 mt-md-5 pt-md-1 pt-lg-0 px-2   ">
                    <h1 className="company_title ">Welcome</h1>
                    <span className="span px-2">Lorem Ipsum is simply dummy text of the
                    printing and typesetting industry</span>
                    <div className="d-flex justify-content-around mx-lg-3 mx-5 mx-md-5 pt-2">
                         <Link to="/"  className="loginbtn text-decoration-none  disabled_button">
                             Log in 
                        </Link>                    
                        <Link to="/register"  className="loginbtn text-decoration-none ml-3">
                            Register
                        </Link>    
                    </div>
                </div>
                </div>

                <div className="centerArrowOutDiv">
                    <div className="arrowIcon text-center d-none d-lg-block d-md-block d-xl-block">
                        <img src={ require('../assets/images/login_right_arrow.png') } alt="img" />
                    </div>
                </div>
               

                <div className="  bg-white text-center loginDiv mt-3   ">
               
                <h3 className="font-weight-normal mt-lg-0 mb-lg-4 mb-0 mt-5  pt-lg-2">Log in</h3> 
                <Form className="text-center form mx-0 mx-lg-4 mx-md-4"  noValidate validated={formValidated} onSubmit={formSubmit}> 
                   

                    <main>
                        <PhoneInput
                        placeholder="Mobile number"
                        className="custom-phone-input"
                        label="Mobile number"
                        international
                        defaultCountry="US" 
                        countryCallingCodeEditable={false} 
                        value={phoneNumber}
                        onChange={setPhoneNumber}/> 
                        <div className="invalid-feedback d-block">{phoneNumber ? (isValidPhoneNumber(phoneNumber) ? undefined : 'Invalid phone number') : 'Phone number required'}</div> 
                    </main>


                    <main>
                    <InputGroup> 
                        <i onClick={passwordToggle} className={showPassword ? 'input-password-icon fa fa-eye-slash' : 'input-password-icon fa fa-eye'}></i>
                        <Form.Control
                            type={showPassword ? 'text' : 'password'} 
                            ref={passwordInput}
                            className="input-area"
                            required
                        /> 
                        <Form.Label className="label">Password</Form.Label>
                        <Form.Control.Feedback type="invalid">
                                Enter Password
                        </Form.Control.Feedback>  
                    </InputGroup>  
                    </main>

                


                     
                    <div className="pt-4">
                    <button type="submit" className="loginbutton mt-lg-3">Log in</button>
                    <a href="#" className="text-dark "><u>Forgot Password?</u></a>
                    </div>
                </Form>
                </div>
               
            </div> 
        </>
    );
  }
  
  export default Login;